// AWS Amplify v6 configuration
const awsmobile = {
  Auth: {
    Cognito: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_jcwxFWs3M',
      userPoolClientId: '10jglehqvjjt5g7eofv88f9jd9',
      signUpVerificationMethod: 'code'
    }
  }
}

export default awsmobile
